import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/contact/page.tsx");
